import { useLayoutEffect } from 'react';
import { useSetAtom } from 'jotai';
import AppLoading from '../../components/App/AppLoading';
import { LogoutMetabase } from '../../components/Metabase/MetabaseLogout';
import { useAuth } from '../../services/auth0';
import { onHeapLogout } from '../../services/heap';
import { isLoggingOutState } from '../../store/global.store';
import { clearLocalStorage } from '../../store/store.utils';

/**
 * this route will clean localstorage and logout auth0
 */
const Logout = () => {
  const { logoutAuth0 } = useAuth();
  const setIsLoggingOut = useSetAtom(isLoggingOutState);

  // useLayoutEffect (not useEffect) so the flag is set before paint, closing
  // the window where a background query could still slip in a token refresh
  useLayoutEffect(() => {
    setIsLoggingOut(true);
    clearLocalStorage();
    sessionStorage.clear();
    onHeapLogout();
    logoutAuth0();
  }, []);

  return (
    <>
      <AppLoading />
      <LogoutMetabase />
    </>
  );
};

export default Logout;
